import { STAFF_ROLE_LABELS } from '../../constants/staff';

// bk-1865 — backdated-discharge signal. ONE shared model for the dashboard
// tile and the desk Today view (never a second count: n = items.length).
// COPY: pending ratification.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const BACKDATED_LIST_VISIBLE = 10;
const DECEASED = 'DECEASED';

export function selectBackdatedCompletions(payload) {
  const items = payload && payload.backdated_completed_today;
  return Array.isArray(items) ? items : [];
}

// 'YYYY-MM-DD' -> 'DD Mon' by string parts (no Date => no UTC/IST drift).
export function formatDayMon(ymd) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || '');
  if (!m) return '';
  return `${m[3]} ${MONTHS[Number(m[2]) - 1] || ''}`.trim();
}

export function backdatedLineCopy(n) {
  if (!n || n < 1) return '';
  return n === 1
    ? '+1 backdated discharge completed today'
    : `+${n} backdated discharges completed today`;
}

function roleLabel(role) {
  if (!role) return '';
  if (STAFF_ROLE_LABELS[role]) return STAFF_ROLE_LABELS[role];
  // no label for this code -> humanised code (e.g. BILLING -> Billing)
  const s = String(role).toLowerCase().replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function backdatedRowCopy(item) {
  const k = item.days_back;
  const reason = item.reason
    || (item.discharge_type === DECEASED ? 'Time of death recorded' : 'Not recorded');
  const parts = [
    item.patient_name,
    item.ip_number,
    `Discharged ${formatDayMon(item.discharged_date)} (${k} ${k === 1 ? 'day' : 'days'} back)`,
    `Reason: ${reason}`,
  ].filter(Boolean);
  if (item.completed_by_name) {
    const role = roleLabel(item.completed_by_role);
    parts.push(`By: ${item.completed_by_name}${role ? ` (${role})` : ''}`);
  }
  return parts.join(' · ');
}

// Deposit-sheet row tag; '' when the row is not a backdated discharge.
export function backdatedDischargeTag(row) {
  const d = row && row.backdated_discharge_date;
  return d ? `Backdated discharge · ${formatDayMon(d)}` : '';
}
